import { defineStore } from 'pinia'

export const useCouponStore = defineStore('coupon', {
    state: () => ({
        couponData: null
    }),

    actions: {
        // 更新整个表单
        updateCoupon(coupon) {
            this.couponData = coupon
        },

        // 设置代金券
        setCoupon(coupon) {
            this.couponData = coupon
        },

        getCoupon() {
            return this.couponData
        }
    },

    // 持久化（可选）：刷新页面数据不丢失
    persist: {
        enabled: true,
        strategies: [
            { storage: localStorage, paths: ['couponData'] }
        ]
    }
})